import { configureStore } from '@reduxjs/toolkit'
import { useSelector, type TypedUseSelectorHook } from 'react-redux'
import globalStateReducer from 'redux/slices/globalState'

import { mainAdminSplitApi, mainApiSplitApi } from './mainSplitApi'

export const store = configureStore({
  reducer: {
    globalState: globalStateReducer,
    [mainAdminSplitApi.reducerPath]: mainAdminSplitApi.reducer,
    [mainApiSplitApi.reducerPath]: mainApiSplitApi.reducer
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false
    }).concat(mainAdminSplitApi.middleware, mainApiSplitApi.middleware)
  }
})
export type RootState = ReturnType<typeof store.getState>

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export const dispatch = store.dispatch
